const committeesRoles = [
    { value: 'Chairperson', name: 'Chairperson', },
    { value: 'Member', name: 'Member' },
    { value: 'Whip', name: 'Whip' }
];
export default committeesRoles;